import { ChangeDetectionStrategy, Component, computed, input, signal } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { stripEmailMarkup } from 'src/app/pipes/support/strip-email-markup.pipe';
import { splitEmailSections } from './split-email-sections';

@Component({
  selector: 'app-email-message',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './email-message.component.html',
  styleUrls: ['./email-message.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EmailMessageComponent {
  message = input<string>();

  sections = computed(() => splitEmailSections(stripEmailMarkup(this.message() ?? '')));
  showPrevious = signal(false);

  togglePrevious(): void {
    this.showPrevious.update(shown => !shown);
  }
}
